import styled from '@emotion/styled';
import { theme } from 'styles/theme/theme';

export const MainBlock = styled.div`
  display: flex;
  flex-direction: row;
  background: white;

  width: 100%;
  height: 72px;
  border-radius: 8px;
  box-shadow:
    0 8px 16px 0 #1a1a2914,
    0 0 1px 0 #1a1a2914;
  padding: 16px 20px;

  &:hover {
    cursor: pointer;
    background-color: #fffbeb;
  }

  transition: background-color 0.2s ease;

  @media (max-width: 768px) {
    flex-direction: column;
    height: auto;
    gap: 12px;
    padding: 14px;
  }
`;

export const ImageBlock = styled.div`
  width: 40px;
  height: 40px;
  min-height: 40px;
  min-width: 40px;
  border-radius: 8px;
  border: 1px solid ${theme.colors.SurfaceCultured10};
  overflow: clip;
`;

export const Image = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;

export const InfoContainer = styled.div<{ gap?: number; width?: number }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${(props) => props.gap || 0}px;
  width: ${(props) => props.width || 'unset'}px;
  min-width: ${(props) => props.width || 'unset'}px;
  white-space: nowrap; /* Текст не переносится */
  overflow: hidden; /* Обрезаем всё за пределами блока */
  text-overflow: ellipsis; /* Добавляем многоточие */

  @media (max-width: 768px) {
    width: 100% !important;
    min-width: 0 !important;
    flex-wrap: wrap;
    white-space: normal;
    row-gap: 8px;

    justify-content: start !important;
  }
`;

export const Divider = styled.div`
  &::after {
    content: '';
    display: block;
    width: 1px;
    height: 40px;
    background: ${theme.colors.DarkBlue100};
    margin-left: 25px;
    margin-right: 25px;
  }

  @media (max-width: 768px) {
    &::after {
      width: 100%;
      height: 1px;
      margin: 8px 0;
    }
  }
`;

export const SportType = styled.div`
  background: ${theme.colors.BorderGray50};
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  padding: 7px 14px;
  border-radius: 10px;
`;
